import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"height":"34px"}
}
const _hoisted_2 = { class: "viewport rel" }
const _hoisted_3 = {
  class: "abs-wrap",
  style: {"padding":"0 40px 0 0","z-index":"1","top":"15px"}
}

import Index from './Index.vue'
import ScTabs from './country/tabs.vue'
import { isMultiStore } from '@/store'
import { sourceCountryRef } from './country'
import { useStore } from 'vuex'
import { watch } from 'vue'
// watch(() => sourceCountryRef.value, (newValue) => {
//   console.log('sourceCountryRef changed:', newValue)
// }, {
//   immediate: true
// })

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const membership = store.getters.membership

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rel", { 'no-vip-kr-style': _unref(membership).templateLevel === 0 && _unref(isMultiStore)() }])
  }, [
    _createVNode(Index, { key: _unref(sourceCountryRef) }, {
      tabs: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(isMultiStore)())
              ? (_openBlock(), _createBlock(ScTabs, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withCtx(() => [
        (_unref(isMultiStore)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})